import React from 'react';
import './Spacer.scss';

export interface SpacerProps {
  size?: 'none' | '1px' | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  onClick?: () => void;
  'aria-label'?: string;
}

const Spacer: React.FC<SpacerProps> = ({
  size = 'md',
  className = '',
  onClick,
  'aria-label': ariaLabel,
}) => {
  const baseClass = 'spacer';
  const sizeClass = `spacer--${size}`;

  const classes = [
    baseClass,
    sizeClass,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div
      className={classes}
      onClick={onClick}
      aria-label={ariaLabel}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
    </div>
  );
};

export default Spacer; 